define([
    'santaPreviewComponents/components/components'
], function (components) {
    'use strict';

    return {
        components
    };
});
